import ChipMain from "../../../UIcomponentsRedesign/Chip/ChipMain";
import classes from "./ChipsBox.module.scss";

export type CategoryItems = {
  label: string;
  items: string[] | string | boolean;
  onDeleteItem?: (item: string) => void;
  onDeleteBoolean?: (item: boolean) => void;
};

type ChipsBoxProps = {
  categories: CategoryItems[];
  showResetAll: boolean;
  onResetAll: () => void;
  id: string
};

const ChipsBox = ({ categories, showResetAll, onResetAll, id }: ChipsBoxProps) => {
  const booleanLabels: Record<string, string> = {
    isClients: 'только клиенты',
    isAgents: 'только агенты',
    isClientsAgents: "клиенты агента",
    isExistedOnPyrus: "есть в Pyrus"
  };
  return (
    <>
      {showResetAll &&
        <div className={classes.chipFlex} id={id}>
          <ChipMain
            key="reset-all"
            label="сбросить все фильтры"
            onClick={onResetAll}
            color="white_blue"
          />
          {categories.map((category) => {
            const items = Array.isArray(category.items) ? category.items : [category.items];

            return items
              .filter((item): item is string | boolean => typeof item === 'string' || typeof item === 'boolean') // Type guard to ensure proper type
              .map((item) => {
                const label = typeof item === 'boolean'
                  ? item ? booleanLabels[category.label] : null
                  : item;
                if (label) {
                  return (
                    <ChipMain
                      key={`${category.label}-${label}`}
                      label={label}
                      onDelete={() => {
                        if (typeof item === 'string' && category.onDeleteItem) {
                          category.onDeleteItem(item);
                        } else if (typeof item === 'boolean' && category.onDeleteBoolean) {
                          category.onDeleteBoolean(item);
                        }
                      }}
                      color="white"
                    />
                  );
                }

                return null;
              });
          })}
        </div>
      }
    </>
  );
};
export default ChipsBox;